import React from 'react';

interface FooterProps {}

const Footer: React.FC<FooterProps> = () => {
  return (
    <footer className="footer">
      <div className='containerFooter'>
        <p>Razão social: Tenorio & Braga Company LTDA. CNPJ: 61.073.431/0001-72</p>
        <p>Contato: support@tbsoftwares.com.br ou (81) 99664-1561</p>
        <p>&copy; {new Date().getFullYear()} T&B Softwares. Todos os direitos reservados.</p>
      </div>
    </footer>
  );
};

export default Footer;